<template>
    <ProduzioneDistintaAvanzamento class="ma-5" @go_back="goBack" />
</template>
<script>
import ProduzioneDistintaAvanzamento from "@/components/PRODUCTION/ProduzioneDistintaAvanzamento/ProduzioneDistintaAvanzamento.vue";

export default {
  name: "",
  components: { ProduzioneDistintaAvanzamento },
  props: {},
  data() {
    return {
        // Variabili d'appoggio
        // Modal
        // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    goBack(){
      this.$router.push("/home/production");
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>